module.exports = __webpack_public_path__ + "img/high-charging-end.8eea75f6.png";